// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"6f442357","304":"11329a44","371":"536b6095","880":"54146211"}[chunkId] + ".chunk.css";
};